import * as React from "react";
import { observer } from "mobx-react";

export interface IToolbarProps {
	modus?: ToolbarModus;
}

export enum ToolbarModus {
	InSelection,
	Search,
	default
}

@observer
export class Toolbar extends React.Component<IToolbarProps, {}> {

	get toolbarClass(): string {
		let classValue = "toolbar";
		switch (this.props.modus) {
			case ToolbarModus.InSelection:
				classValue = "toolbar is--toolbarmove";
				break;
			case ToolbarModus.Search:
				classValue = "toolbar is--searchField";
				break;
			default:
				break;
		}
		return classValue;
	}

	render() {
		return <div className={this.toolbarClass}>
			{this.props.children}
		</div>;
	}
}
